import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material";
import PaymentsChart from "./chart";
import { IIncomeReports } from "src/types/business-intelligence";
import sarIcon from "src/assets/svg-icons/sar.svg";
import exclamationMarkIcon from "src/assets/svg-icons/exlamation-mark.svg";

const Payments = ({ data }: { data: IIncomeReports | undefined }) => {
  return (
    <Stack
      borderRadius={"8px"}
      boxShadow={" 0px 2.232px 11.161px 0px rgba(0, 0, 0, 0.10)"}
      pt={{ xs: 2, lg: 3 }}
      pb={{ xs: 1, lg: 1 }}
      bgcolor={"#242424"}
    >
      <Grid container px={4}>
        <Grid item xs={4}>
          <Typography
            fontSize={"12px"}
            fontWeight={600}
            color={"#CFCFCF"}
            mb={"3px"}
          >
            Paid
          </Typography>

          <Typography
            fontSize={{ xs: "14px", lg: "16px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            <img height={14} src={sarIcon} alt="" />{" "}
            {data?.total.completedAmount.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Stack direction={"row"} spacing={1} mb={"3px"}>
            <Typography
              fontSize={{ xs: "12px" }}
              fontWeight={600}
              color={"#CFCFCF"}
            >
              Free
            </Typography>
            <Tooltip
              title="This amount reflects the Give For Free tickets, not the B2B"
              placement="right"
            >
              <img src={exclamationMarkIcon} alt="" />
            </Tooltip>
          </Stack>

          <Typography
            fontSize={{ xs: "14px", lg: "16px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            <img height={14} src={sarIcon} alt="" /> {data?.total.freeAmount.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography
            fontSize={"12px"}
            fontWeight={600}
            color={"#CFCFCF"}
            mb={"3px"}
          >
            Refunded
          </Typography>
          <Typography
            fontSize={{ xs: "14px", lg: "16px" }}
            fontWeight={500}
            color={"#FFF"}
          >
            <img height={14} src={sarIcon} alt="" /> {data?.total.refundedAmount.toLocaleString()}
          </Typography>
        </Grid>
      </Grid>

      <Box
        width={"100%"}
        bgcolor={"#000000"}
        height={"2.3px"}
        my={{ lg: 3, xs: 2 }}
      />
      <PaymentsChart data={data} />
    </Stack>
  );
};

export default Payments;
